import React from 'react';

// Components
import { Box } from '@mui/material';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';

const NoAuthorizationsAvailable = () => (
  <Box
    bgcolor="graphic.lighter"
    borderRadius="4px"
    color="text.secondary"
    fontFamily="Gothic A1"
    fontWeight={300}
    ml={{ md: 1 }}
    mt={{ md: 1 }}
    padding={3}
    textAlign="center"
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    width={{ xs: '100%', sm: 326 }}
  >
    <BlockRoundedIcon
      sx={{
        height: 38,
        mb: 1,
        width: 38,
      }}
    />
    <Box component="p" fontSize={20} my={1}>
      No available authorizations.
    </Box>
    <Box component="p" fontSize={16} mb={0.5} mt={0}>
      Try adjusting your search or filter options.
    </Box>
  </Box>
);

export default NoAuthorizationsAvailable;
